<template>
    <div>
        <div v-if="activities.length > 0" class="row">
            <activity-card
                v-for="activity in activities"
                :key="activity.id"
                class="col-12 col-md-6 col-xl-4 mb-4"
                :activity="activity"
            ></activity-card>
        </div>
    </div>
</template>

<script>
import activityCard from '@/components/cards/activity-card';
export default {
    components: {
        activityCard
    },
    props: {
        activities: {
            type: Array,
            default() {
                return [];
            }
        }
    }
};
</script>
